import Bugsnag from '@bugsnag/js'

function notifyError(error) {
  Bugsnag.notify(error);
}

export { notifyError };